// extracted by mini-css-extract-plugin
module.exports = {"gridRow":"styles_gridRow__0mcCd","title":"styles_title__laOne","valueWrapper":"styles_valueWrapper__2a3II","rawData":"styles_rawData__gwKSv"};